/**
 * SMS schools service — migrated to typed `@tiaki/http-client` per ADR 113.
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface UserSchoolFilters {
  search?: string;
  query?: string;
  limit?: number;
  offset?: number;
  baseuser: number;
  ordering?: string;
  deleted?: boolean;
}
export interface UserSchoolMembershipListResponse {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results: UserSchoolMembership[];
}
export interface UserSchoolMembershipFilters {
  baseuser?: number;
  offset?: number;
  limit?: number;
  ordering?: string;
}
export interface LocationDetail {
  id: number;
  room_name: string;
  maps_people_room_id: string | null;
  safe: boolean | null;
  school: number;
  school_name: string;
  maps_people_apikey: string | null;
  building_id: number;
  building_name: string;
  maps_people_building_id: string | null;
  floor_id: number;
  floor_name: string;
  maps_people_floor_id: string | null;
}

export interface UserSchoolMembership {
  id: number;
  baseuser: number;
  school: number;
  included_in_internal: boolean;
  included_in_approval: boolean;
  default_location1: number | null;
  default_location2: number | null;
  default_location3: number | null;
  default_location4: number | null;
  default_location5: number | null;
  check_in: boolean;
  location_details: LocationDetail[];
  school_name: string;
}
export interface SchoolSite {
  id: number;
  organization_id: number;
  organization_name: string;
  organization_status: string;
  organization_public_id: string;
  organization_jwt_secret: string;
  map_provider: string;
  map_provider_key: string;
  floorplan_provider: string;
  floorplan_provider_key: string;
  start_report_enabled: boolean;
  is_test_site: boolean;
  can_share_alerts: boolean;
  timezone: string;
  json_map_url: string | null;
  deleted: string | null;
  deleted_by_cascade: boolean;
  public_id: string;
  name: string;
  status: string;
  svg: string | null;
  json_map: string | null;
  icon: string | null;
  address: string;
  address_2: string;
  zip: string | null;
  city: string;
  state: string;
  country: string;
  alerts_enabled: boolean;
  boards_enabled: boolean;
  chat_enabled: boolean;
  maps_enabled: boolean;
  drill_enabled: boolean;
  maps_people_apikey: string;
  maps_people_venue_id: string;
  show_safe_unsafe: boolean;
  digital_911_enabled: boolean;
  latitude: string;
  longitude: string;
  same_geocodes: unknown | null;
  cap_polygon: unknown | null;
  elevation: number;
  phone_number: string | null;
  map_pin_enabled: boolean;
  district: number;
  peer_sites: number[];
  cleartouch_api_token: string;
  cleartouch_app_key: string;
  cleartouch_app_secret: string;
  cleartouch_device_groups: unknown[];
  cleartouch_school_code: string;
  imdf_source_file: string | null;
  site_type: string;
  stream_api_key: string;
  stream_app_key: string;
  stream_app_secret: string;
  stream_auth_mode: string;
  stream_client_id: string;
  stream_client_secret: string;
  stream_org_id: string;
  stream_refresh_token: string;
  system_admin: string;
  token_days: number | null;
  token_test: boolean | null;
  check_in: boolean;
  baseuserschool_id: number;
  alert_data: AlertData;
  drill_data: DrillData;
  report_data: ReportData;
}

export interface AlertData {
  labels: {
    start: string;
  };
}

export interface DrillData {
  labels: {
    start: string;
  };
  optionDefaults: {
    silent: boolean;
  };
}

export interface ReportData {
  labels: {
    start: string;
  };
}
export async function getUserSchoolMembership(
  filters: UserSchoolMembershipFilters = {},
): Promise<UserSchoolMembershipListResponse> {
  const query: Record<string, unknown> = {};
  if (filters.baseuser !== undefined) query.baseuser = filters.baseuser;
  if (filters.offset) query.offset = filters.offset;
  if (filters.limit) query.limit = filters.limit;
  if (filters.ordering) query.ordering = filters.ordering;

  const result = await client.GET('/api/v2/user-school-membership/', {
    params: { query: query as never },
  });
  return unwrap(result) as unknown as UserSchoolMembershipListResponse;
}
export async function getSchoolDetail(id:string): Promise<SchoolSite> {
  const result = await client.GET('/api/v2/school/{id}/', {
    params: { path: { id } as never },
  });  return unwrap(result) as unknown as SchoolSite;

}
